import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily?: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      cityPassOuterContainer: {
        padding: '0px 24px 24px 24px',
        minWidth: '100%',
        background: 'transparent'
      },
      cityPassInnerContainer: {
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        borderRadius: '8px',
        minWidth: '100%',
        overflow: 'hidden',
        height: '809px',
        background: 'white',
        padding: '32px 64px 24px 64px',
        justifyContent: 'space-between',
        color: '#2A2A2A',
        flexWrap: 'nowrap',
        [theme.breakpoints.down('lg')]: {
          height: '1620px',
          padding: '32px 20px',
          marginBottom: '16px'
        },
        [theme.breakpoints.only('lg')]: {
          height: '755px',
          marginBottom: '0px',
          padding: '20px'
        }
      },
      cityPassContentArea: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        width: '100%',
        height: '100%',
        [theme.breakpoints.down('lg')]: {
          flexDirection: 'column'
        }
      },
      cityPassHeaderArea: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        flex: '1 0 auto',
        [theme.breakpoints.down('lg')]: {
          width: '100%'
        }
      },
      cityPassHeading: {
        flex: 'none',
        background: 'transparent',
        margin: '0px 0px 16px 0px',
        [theme.breakpoints.down('lg')]: {
          padding: '0px 0px 0px 40px',
          width: '100%'
        },
        [theme.breakpoints.only('lg')]: {
          padding: '0px 0px 0px 8px'
        }
      },
      imageBox: {
        width: '450px',
        height: '550px',
        textAlign: 'center',
        display: 'flex',
        flex: '0 1 450px'
      },
      cityPassTableArea: {
        margin: '20px',
        flex: '0 1 940px',
        [theme.breakpoints.down('lg')]: {
          margin: '60px 20px 20px',
          height: '650px'
        }
      },
      tableContainer: {
        width: 'calc(100% - 10px)',
        margin: '0 5px 40px'
      },
      tableHeadCell: {
        fontFamily: props.fontFamily,
        fontWeight: 600,
        lineHeight: 1.13,
        whiteSpace: 'nowrap',
        flex: '1',
        background: 'rgb(255, 255, 255)',
        fontSize: '22px',
        border: 0,
        '&:first-child': {
          marginLeft: '15px'
        }
      },
      tableBodyCell: {
        whiteSpace: 'nowrap',
        overflowWrap: 'anywhere',
        background: '#ffffff00',
        flex: '1',
        fontSize: '22px',
        border: 0,
        '&:first-child': {
          marginLeft: '15px'
        }
      },
      cpLevelCell: {
        flex: '0 0 280px',
        [theme.breakpoints.down('lg')]: {
          flex: '0 0 270px'
        }
      },
      cpBarcodeCell: {
        textAlign: 'left'
      },
      cpRemoveHeadCell: {
        flex: '0 0 120px',
        [theme.breakpoints.down('lg')]: {
          flex: '0 0 80px'
        }
      },
      cpRemoveCell: {
        flex: '0 0 110px',
        [theme.breakpoints.down('lg')]: {
          flex: '0 0 80px'
        }
      },
      tableHeadRows: {
        display: 'flex',
        alignItems: 'center',
        border: 0,
        width: '100%',
        padding: '10px 0px',
        borderRadius: '8px',
        backgroundColor: '#fff'
      },
      tableRows: {
        display: 'flex',
        alignItems: 'center',
        border: 0,
        width: '100%',
        padding: '8px 0',
        borderRadius: '8px',
        boxShadow: '0 1px 9px 0 rgba(0, 0, 0, 0.2)',
        backgroundColor: '#fff',
        margin: '20px 0px',
        '&:first-child': {
          margin: '0 0 20px'
        }
      },
      cpBottomArea: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '20px'
      },
      cpFooterBtnsPortrait: {
        display: 'none',
        [theme.breakpoints.down('lg')]: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0px 10px',
          margin: '20px 0px'
        },
        [theme.breakpoints.only('lg')]: {
          margin: '15px 0px'
        }
      },
      footerMidddleBtn: {
        flex: 'none',
        background: 'transparent',
        display: 'block',
        [theme.breakpoints.down('lg')]: {
          display: 'none'
        }
      },
      lookupSearchContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px 24px 24px 24px',
        minWidth: '100%',
        background: 'transparent'
      },
      lookupSearchInnerContainer: {
        background: 'white',
        minWidth: '100%',
        borderRadius: '8px',
        height: '809px',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        alignItems: 'start',
        justifyContent: 'center',
        display: 'flex',
        [theme.breakpoints.down('lg')]: {
          height: '1640px'
        }
      },
      ticketSearchInput: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        flexWrap: 'nowrap',
        justifyContent: 'center',
        [theme.breakpoints.down('lg')]: {
          height: '1385px'
        }
      },
      ticketSearchSubHeading: {
        textAlign: 'center',
        fontSize: '30px',
        [theme.breakpoints.down('lg')]: {
          width: '612px',
          padding: '0px'
        }
      },
      numpadContainer: {
        position: 'absolute',
        padding: '24px 0px 0px 0px',
        background: '#EFEFEF',
        bottom: '0px',
        height: '520px',
        width: '1900px',
        [theme.breakpoints.down('lg')]: {
          height: '650px',
          width: '1050px'
        }
      },
      ticketNumInputBox: {
        width: '932px',
        background: 'transparent',
        margin: '30px 0px 64px 0px',
        [theme.breakpoints.down('lg')]: {
          width: '822px',
          margin: '16px 0px 64px 0px'
        }
      }
    })
  );
